export const adjustDataResponse = data => {
  const hardCodeFields = {
    monetization: {
      name: 'Setra 515 HD, K756BM',
      template: {
        name: 'Перевозка в Комарово',
        normativeTime: {
          time1: 33,
          time2: 30,
          time3: 30,
          time4: 60,
        },
        minTime: 240,
        priceMinute: 15,
        priceMinuteDelay: {
          price: 30,
          minTime: 15,
        },
        priceStop: {
          price: 30,
          minTime: 15,
        },
        priceStopMedium: {
          price: 30,
          minTime: 15,
        },
        priceStopEnd: {
          price: 30,
          minTime: 15,
        },
        priceClientVariation: {
          price: 30,
          minTime: 15,
        },
        priceAfterEnd: {
          price: 30,
          minTime: 15,
        },
        priceOverrun: {
          price: 30,
          minTime: 15,
        },
        mkad: 'Без привязки к МКАД',
      },
    },
    // orderPrice Section
    paidTime: 'Оплачиваемое время по заказу (270 мин)',
    additionalDist: '270',
    additionalServices: 'Выбраны 3 услуги',
    additionalServices1: 2750,
    additionalServices2: 1000,
    additionalServices3: 1000,
    customService: [
      {
        name: 'Доп. услуга 1',
        price: 1200,
      },
      {
        name: 'Доп. услуга 2',
        price: 2200,
      },
    ],
    priceUseVehicle: 60,
    priceExtraKm: 20,
    priceDiscount: 200,
    priceFinal: 27630,
    priceFinalNDS: 5526,
    totalPrice: 33156,

    // paymantType Section
    // priceAddPayment: 'Безналичный расчет (по умолчанию)',

    // document Section
    // document: 'Заказчик',
    // documentPassengers: 'Исполнитель',
    // documentDriver: 'Заказчик',
  };
  let newData = {
    accompCount: data.accompCount,
    arrivalDatetime: data.arrivalDatetime,
    kidsCount: data.kidsCount,
    number: data.number,
    passengersCount: data.passengersCount,
    usingTime: data.usingTime,
    ...hardCodeFields,
  };
  if (data.requestId) {
    newData.requestId = data.requestId;
  }
  if (data.paymentMethodId) {
    newData.paymentMethod = data.paymentMethodId.paymentMethodKey;
  }
  if (data.profileId) {
    newData.profileId = data.profileId;
  }
  if (data.maintenanceLevels) {
    newData.maintenanceLevels = data.maintenanceLevels.map(
      item => item.maintenanceLevelKey
    );
  }
  if (data.comment) {
    newData.comment = data.comment
  }
  // if (data.profileId){
  //   if (data.profileId.profileId){
  //     newData.profileId = data.profileId.profileId
  //   }
  // }
  if (data.profileId && data.profileId.userId){
    let user = data.profileId.userId;
    if (user.phone) {
      let phone = user.phone.match(/^(\+7|\+380|\+375)(.*)/);
      if (phone) {
        // newData.phoneCode = company.phoneCode;
        // newData.phoneNumber = company.phone;
        newData.phoneCode = phone[1];
        newData.phoneNumber = phone[2];
      }
    }
    if (user.email) {
      newData.email = user.email;
    }
  }
  if (data.profileId && data.profileId.companyId) {
    let company = data.profileId.companyId;
    if (company.nameLegal) {
      newData.nameLegal = company.nameLegal;
    }
    if (company.passportNumber) {
      newData.passportNumber = company.passportNumber;
    }
    if (company.passportSeries) {
      newData.passportSeries = company.passportSeries;
    }
    if (company.birthDate) {
      newData.birthDate = company.birthDate;
    }
    if (company.addressLegal) {
      newData.addressLegal = company.addressLegal;
    }
    if (company.companyId) {
      newData.companyId = company.companyId;
    }
    if (company.lastname) {
      newData.lastname = company.lastname;
    }
    if (company.name) {
      newData.name = company.name;
    }
    if (company.patronymic) {
      newData.patronymic = company.patronymic;
    }
    if (company.inn) {
      newData.inn = company.inn;
    }
    if (company.subjectId && company.subjectId.subjectKey) {
      newData.subject = company.subjectId.subjectKey;
    }
  }
  if (data.requestStatusId && data.requestStatusId.requestStatusKey) {
    newData.requestStatus = data.requestStatusId.requestStatusKey;
  }
  if (data.requestTypeId && data.requestTypeId.requestTypeId) {
    newData.requestType = data.requestTypeId.requestTypeKey;
  }
  if (data.requestViewId && data.requestViewId.requestViewKey) {
    newData.requestView = data.requestViewId.requestViewKey;
  }
  if (data.serviceAdditional && data.serviceAdditional.length > 0) {
    newData.serviceAdditional = data.serviceAdditional;
  }
  if (data.serviceTypeId && data.serviceTypeId.serviceTypeKey) {
    newData.serviceType = data.serviceTypeId.serviceTypeKey;
  }
  if (data.routes && data.routes.length > 0) {
    newData.routes = data.routes;
    newData.routeLength = data.routes.length;
    newData.placeDelivery = data.routes[0].route;
    // newData.placeDelivery = {
    //   city: data.routes[0].route.split(',')[0],
    //   address: data.routes[0].route
    //     .split(',')
    //     .slice(1)
    //     .join(',')
    //     .trim()
    // };
    newData.finalDestination = data.routes[data.routes.length - 1].route;
    // newData.finalDestination = {
    //   city: data.routes[data.routes.length - 1].route.split(',')[0],
    //   address: data.routes[data.routes.length - 1].route
    //     .split(',')
    //     .slice(1)
    //     .join(',')
    //     .trim()
    // }
  }
  if (
    newData.serviceType === 'kids' &&
    parseInt(newData.passengersCount) === 0
  ) {
    newData.passengersCount = newData.kidsCount;
  }
  return newData;
};
